import { useCallback } from 'react'
import { useSubmitRegisterFormMutation } from '../../common/graphql/__generated__/graphql.autogenerated'
import { SignupFormSchema } from '../model/SignupForm'

const useSignupFormSubmit = () => {
  const [submitRegisterFormMutation, { data, loading, error }] =
    useSubmitRegisterFormMutation()

  const onSubmit = useCallback((formData: SignupFormSchema) => {
    return submitRegisterFormMutation({
      variables: {
        data: {
          formData: JSON.stringify(formData),
        },
      },
    })
  }, [])

  return { data, isSubmitting: loading, error, onSubmit }
}

export default useSignupFormSubmit
